import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import KeyboardComponent from "./KeyboardComponent";
import "./Main.scss";
import WebSocketComponent, { WebSocketProvider } from "./WebsocketComponent";

/** Main wrapper for the whole app. */
function Main(): JSX.Element {

	return (
		<WebSocketProvider>
			<div className="Main">
				<Router>
					<Routes>
						<Route path="/" element={
							<>
								<KeyboardComponent />
								<WebSocketComponent />
							</>
						}
						/>
					</Routes>
				</Router>
			</div>
		</WebSocketProvider>
	);
}

export default Main;
